/**
 * Areas Catalog Hook
 */

import { useState, useEffect } from 'react';
import { areasCatalogService } from '../areas.service.ts';
import type { Area } from '../areas.types.ts';


interface UseAreasResult {
  areas: Area[];
  loading: boolean;
  error: string | null;
}

export function useAreas(): UseAreasResult {
  const [areas, setAreas] = useState<Area[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    void (async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await areasCatalogService.getAreas();

        if (!isMounted) return;

        if (response.success && response.data) {
          setAreas(response.data);
        } else if (response.error) {
          setError(response.error.description || 'Error loading areas');
        }
      } catch (catchError) {
        if (!isMounted) return;
        setError(catchError instanceof Error ? catchError.message : 'Unknown error');
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    })();

    return () => {
      isMounted = false;
    };
  }, []);

  return { areas, loading, error };
}
